<template>
    <div class="contact">
        <swiper>
            <swiper-slide class="contact-tiny" v-for="(item, index) in list" :key="index">
                <img :src="item" alt="" srcset="">
            </swiper-slide>
        </swiper>
        <InnerTitle :class="[swidth > 768 ? 'w-3333' : 'w-90', ' ml-auto mr-auto']" :list="titles" @action="actionFunc"
            :active="active"></InnerTitle>

        <div class="global-margin global-inner flex justify-evenly tab1" v-if="swidth > 768">
            <div class="left w45" :style="{ paddingLeft: '80px', paddingRight: '10px' }">
                <p class="title">{{ $t("contact.p1") }}</p>
                <p>{{ $t("contact.p2") }}</p>
                <p>{{ $t("contact.p3") }}</p>
            </div>
            <div class="right w55">
                <BaiduMap class="bm-view" ak="5weQfcsCe86Eockyw9QK6W5zGpMVdhMT">
                    <BmLocalSearch keyword="三川田" location="广州" selectFirstResult autoViewport
                        :pageCapacompany_address="1" :panel="false" />
                    <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true"
                        :autoLocation="true"></bm-geolocation>
                </BaiduMap>
            </div>
        </div>
        <div class="global-margin global-inner tab1" v-else>
            <div class="right w-100">
                <BaiduMap class="bm-view" ak="5weQfcsCe86Eockyw9QK6W5zGpMVdhMT">
                    <BmLocalSearch keyword="三川田" location="广州" selectFirstResult autoViewport
                        :pageCapacompany_address="1" :panel="false" />
                    <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true"
                        :autoLocation="true"></bm-geolocation>
                </BaiduMap>
            </div>
            <div class="left w-100 mt-20">
                <p>{{ $t("contact.p2") }}</p>
                <p>{{ $t("contact.p3") }}</p>
            </div>
        </div>
    </div>
</template>
<script>
import InnerTitle from '../components/InnerTitle.vue';
import BaiduMap from "vue-baidu-map/components/map/Map";
import BmGeolocation from "vue-baidu-map/components/controls/Geolocation";
import BmLocalSearch from "vue-baidu-map/components/search/LocalSearch";


import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
    components: {
        InnerTitle,
        swiper, swiperSlide,
        BaiduMap,
        BmGeolocation,
        BmLocalSearch,
    },
    props: {
        swidth: {
            type: Number
        }
    },
    data() {
        return {
            swiperOptionThumbs: {
                loop: true,
                centeredSlides: true,
                slidesPerView: "auto",
                touchRatio: 0.2,
            },
            list: [],
            lang: localStorage.getItem("333f-locale-lang") || "zh_cn",
            titles: [{
                id: 0,
                title: this.$t("contact.i1"),
            },],
            loading: true,
            active: 0,
        };
    },
    mounted() {
        this.getBannerImg()
    },
    methods: {
        getBannerImg() {

            this.$http.get('/common/category/getList', {
                pid: 0,
                lang_code: this.lang,
                'to-tree': 0
            }).then((res) => {
                if (res.code == 200) {
                    res.data.map(item => {
                        if (item.id === Number(sessionStorage.getItem('333f-now-tab'))) {
                            this.list = [item.banner_url]
                        }
                    })
                    // this.titles = res.data;
                }
            });
        },
        actionFunc(item) {
            this.active = item.id
        },
    },
};
</script>
<style scoped lang="less">
.contact {
    .contact-tiny {
        img {
            width: 100%;
            height: fit-content;
            min-height: 380px;
        }
    }

    .tab1 {
        margin-bottom: 50px;

        .left {
            // padding-left: 80px;
            font-size: 22px;
            color: @text-defauft-color;
            line-height: 36px;

            i {
                color: @primaryColor;
            }

            .title {
                color: @primaryColor;
                font-size: 30px;

                margin-bottom: 30px;
            }
        }

        .right {
            height: 550px;
        }
    }

    .w45 {
        width: 45%;
        ;
    }

    .w55 {
        width: 55%;
    }

    .bm-view {
        width: 100%;
        height: 100%;
        height: 550px;
    }

}

@media (max-width: 900px) {
    .contact-tiny {
        img {
            height: 400px !important;
            object-fit: cover;
        }
    }

}
</style>



// WEBPACK FOOTER //
// src/pages/contact.vue